module.exports = __webpack_public_path__ + "static/media/recovery-img-1.7ec44e6f.png";